import * as React from "react";
import { forwardRef } from "react";
const SvgBadge = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 6.5, cy: 6.5, r: 5.5, fill: "#DE1A22", stroke: "currentColor", strokeWidth: "2px" }));
const ForwardRef = forwardRef(SvgBadge);
export { ForwardRef as ReactComponent };
